<div
  class="percent-container"
  *ngIf="isNumber(percent)"
  [ngStyle]="{
    border: (percent >= 0 && !reverseColor) || (percent < 0 && reverseColor) ? '1px solid #40762a' : '1px solid #f54f45',
    background: (percent >= 0 && !reverseColor) || (percent < 0 && reverseColor) ? '#f4ffef' : '#ffcccc'
  }"
>
  <img
    *ngIf="showUpDown"
    class="arrow-image"
    src="./assets/images/{{ (percent >= 0 && !reverseColor) || (percent < 0 && reverseColor) ? 'arrow_up_green' : 'arrow_up_red' }}.svg"
    [ngClass]="{ 'arrow-down': percent < 0 }"
  />
  <div class="percent-value" [ngStyle]="{ color: (percent >= 0 && !reverseColor) || (percent < 0 && reverseColor) ? '#03a400' : '#f66057' }">
    <span *ngIf="showPositive && percent > 0">+</span>{{ showInfinity ? 'Infinity' : percent }}
    %
  </div>
</div>
